import { useContext } from "react";
import { StyleSheet, Text, View } from "react-native";

import { appColors } from "../constants/colors";
import { CalculationsContext } from "../store/calculationsCtx";
import InputsOuterContainer from "./UI/InputsOuterContainer";
import ResultInput from "./ResultInput";

const isInitialState = (extraPayments, rateChanges) => {
  return extraPayments.length > 0 || rateChanges.length > 0;
};

export default function ResultsContainer() {
  const calculationsCtx = useContext(CalculationsContext);
  const results = calculationsCtx.results;
  const results2 = calculationsCtx.results2;
  const inputs = calculationsCtx.inputs;

  const isChanged = isInitialState(inputs?.extraPayments || [], inputs?.rateChanges || []);

  const DataRow = ({ label, value }) => (
    <View style={styles.row}>
      <Text style={styles.label}>{label}</Text>
      <ResultInput value={value} />
    </View>
  );

  return (
    <InputsOuterContainer>
      {/* Hero instalment pill */}
      <View style={styles.heroRow}>
        <Text style={styles.heroLabel}>{isChanged ? "Base instalment" : "Monthly instalment"}</Text>
        <Text style={styles.heroAmount}>{results.instalment}</Text>
      </View>

      <View style={styles.divider} />

      {isChanged ? (
        <View style={styles.comparisonContainer}>
          <View style={styles.column}>
            <Text style={styles.columnHeader}>Original</Text>
            <DataRow label="Finance" value={results.loan} />
            <DataRow label="Interest" value={results.interestPaid} />
            <DataRow label="Monthly fees" value={results.fees} />
            <DataRow label="Total" value={results.totalPaid} />
          </View>

          <View style={styles.verticalDivider} />

          <View style={styles.column}>
            <Text style={[styles.columnHeader, { color: appColors.accent }]}>With amendments</Text>
            <DataRow label="Finance" value={results.loan} />
            <DataRow label="Interest" value={results2.interest} />
            <DataRow label="Monthly fees" value={results2.fees} />
            <DataRow label="Total" value={results2.total} />
          </View>
        </View>
      ) : (
        <View style={styles.statsGrid}>
          <View style={styles.statBox}>
            <Text style={styles.statLabel}>Finance amount</Text>
            <Text style={styles.statValue}>{results.loan}</Text>
          </View>
          <View style={styles.statBox}>
            <Text style={styles.statLabel}>Total interest</Text>
            <Text style={styles.statValue}>{results.interestPaid}</Text>
          </View>
          <View style={styles.statBox}>
            <Text style={styles.statLabel}>Monthly fees</Text>
            <Text style={styles.statValue}>{results.fees}</Text>
          </View>
          <View style={styles.statBox}>
            <Text style={styles.statLabel}>Total paid</Text>
            <Text style={styles.statValue}>{results.totalPaid}</Text>
          </View>
        </View>
      )}

      {results.msg && (
        <Text style={styles.msg}>{results.msg}</Text>
      )}
    </InputsOuterContainer>
  );
}

const styles = StyleSheet.create({
  heroRow: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },

  heroLabel: {
    fontSize: 12,
    color: appColors.textSecondary,
  },

  heroAmount: {
    fontSize: 22,
    fontWeight: "500",
    color: appColors.primary,
    letterSpacing: -0.5,
  },

  divider: {
    width: "100%",
    height: 0.5,
    backgroundColor: appColors.borderLight,
    marginBottom: 10,
  },

  statsGrid: {
    width: "100%",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },

  statBox: {
    flex: 1,
    minWidth: "45%",
    backgroundColor: appColors.statBg,
    borderRadius: 10,
    padding: 10,
  },

  statLabel: {
    fontSize: 10,
    color: appColors.textSecondary,
    marginBottom: 3,
  },

  statValue: {
    fontSize: 13,
    fontWeight: "500",
    color: appColors.primary,
  },

  // Comparison layout
  comparisonContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginTop: 4,
  },

  column: {
    flex: 1,
    gap: 8,
    paddingHorizontal: 4,
  },

  columnHeader: {
    fontSize: 10,
    fontWeight: "500",
    textAlign: "center",
    marginBottom: 4,
    color: appColors.textMuted,
    textTransform: "uppercase",
    letterSpacing: 0.3,
  },

  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 4,
  },

  label: {
    fontSize: 11,
    color: appColors.textSecondary,
  },

  verticalDivider: {
    width: 0.5,
    backgroundColor: appColors.border,
    marginHorizontal: 6,
  },

  msg: {
    marginTop: 10,
    fontSize: 11,
    fontWeight: "500",
    color: appColors.danger,
    textAlign: "center",
  },
});
